import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { ReceivingMethod } from '../../../../api/def_common_api';
import { useActions } from '../../../../hooks/useActions';
import { useBasket } from '../../../../hooks/useBasket';
import { setStoreLocal } from '../../../../utils/local-storage';

export const useMethodReceiving = () => {
  const { setValue } = useFormContext();
  const { otherValue, checkout } = useBasket();
  const { setCityData, setReceivingMethod } = useActions();
  const [tab, setTab] = useState(false);
  const [activeCity, setActiveCity] = useState<'first' | 'second' | 'third'>(
    'first'
  );
  const toggleSwitch = (type: ReceivingMethod) => {
    setValue('receiving_method', type);
    setReceivingMethod(type);
    if (type === 'self_delivery') {
      setTab(false);
    }
    if (type === 'delivery') {
      setTab(true);
      handleActiveCity('first');
    }
  };

  const handleActiveCity = (active: 'first' | 'second' | 'third') => {
    switch (active) {
      case 'first':
        setValue('city', 'г. Владивосток');
        setStoreLocal('city_value', {
          city: 'г. Владивосток',
          street: 'ул. Дальзоводская, 4, пав. 310',
          phone: '+7 (423) 246-48-64',
        });
        break;
      case 'second':
        setValue('city', 'г. Уссурийск');
        setStoreLocal('city_value', {
          city: 'г. Уссурийск',
          street: 'ул. Краснознамённая, 212',
          phone: '+7 (4234) 34-25-16',
        });
        break;
      case 'third':
        setValue('city', 'г. Находка');
        setStoreLocal('city_value', {
          city: 'г. Находка',
          street: 'ул. Шоссейная, 94в',
          phone: '+7 (4236) 69-86-75',
        });
        break;
    }

    setCityData(active);
    setActiveCity(active);
  };

  return {
    method: { tab, activeCity },
    actions: { toggleSwitch, handleActiveCity, setTab },
  };
};
